// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_2qgV5","separator":"_1W0XB"};